import React from 'react';
import './Modal.css';

const Modal = ({ title, children, isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-container" onClick={e => e.stopPropagation()}>
        <header className="modal-header">
          <h2>{title}</h2>
        </header>
        <div className="modal-body">
          {children}
        </div>
        <footer className="modal-footer">
          <button className="modal-close-btn" onClick={onClose}>
            OK
          </button>
        </footer>
      </div>
    </div>
  );
};

export default Modal;
